import PresentationLibraryController from "js/controllers/PresentationLibraryController";
import WorkspaceController from "js/controllers/WorkspaceController";
import Api from "js/core/api";
import AppController from "js/core/AppController";
import getLogger from "js/core/logger";
import { getPresentation } from "js/core/models/presentation";
import { trackActivity } from "js/core/utilities/utilities";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import ProgressDialog from "js/react/components/Dialogs/ProgressDialog";
import { PermissionActionType, ActionPermissionsObject, WorkspaceResourceType } from "common/interfaces";

const logger = getLogger();

export class PresentationTemplateController {
    static async getTeamTemplates(templateIds = null, editable = false) {
        if (!WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES][PermissionActionType.USE]) {
            return [];
        }

        if (!templateIds) {
            templateIds = WorkspaceController.resources.filter(r => r.resourceType === WorkspaceResourceType.PRESENTATION_TEMPLATE).map(r => r.resourceId);
        }

        // This is very innefficient, must be refactored in the future
        let templates = await Promise.all(templateIds.map(id => getPresentation(id, { permission: editable ? "write" : "read", autoSync: false })));

        /// We should clean up the mess below in the future...
        templates = templates
            .map(template => {
                let {
                    ratedByUsers = {},
                    createdById,
                    modifiedById,
                    ...rest
                } = template.toJSON();
                let ratedByCount = Object.keys(ratedByUsers).length;
                if (!createdById) {
                    createdById = rest.userId;
                }
                if (!modifiedById) {
                    modifiedById = createdById;
                }

                let item = {
                    template,
                    ...rest,
                    createdById,
                    modifiedById,
                    ratedByUsers,
                    ratedByCount,
                    sips: template.getSips()
                };
                return item;
            });

        return templates;
    }

    static async createPresentationTemplate(presentation, fieldUpdates) {
        // duplicate the presentation
        const duplicatedPresentation = await PresentationLibraryController.duplicatePresentation({
            presentationId: presentation.id,
        });

        await this.convertToPresentationTemplate(duplicatedPresentation, fieldUpdates);

        AppController.showEditor({ presentationId: duplicatedPresentation.id });
    }

    // Copied from TeamFoldersController, will be refactored in the future
    static setTemplatePermissions = async templates => {
        const presentationIds = templates.map(selectedPresentation => selectedPresentation.id);

        const progressDialog = ShowDialog(ProgressDialog, {
            title: `Creating template...`,
        });
        const payload = {
            teamId: WorkspaceController.legacyDefaultTeamId,
            resourceIds: presentationIds,
            resourceType: "presentations",
            permission: "write",
            type: "create-template"
        };
        try {
            await Api.teamPermissions.put(payload);
        } catch (err) {
            logger.error(err, "Api.teamPermissions.put() failed", payload);
        }
        progressDialog.props.closeDialog();
    }

    // Copied from TeamFoldersController, will be refactored in the future
    static deleteTemplatePermissions = async templates => {
        const presentationIds = templates.map(selectedPresentation => selectedPresentation.id);

        const progressDialog = ShowDialog(ProgressDialog, {
            title: `Deleting template...`,
        });
        const payload = {
            teamId: WorkspaceController.legacyDefaultTeamId,
            resourceIds: presentationIds,
            resourceType: "presentations",
            permission: "write",
            type: "delete-template"
        };
        try {
            await Api.teamPermissions.put(payload);
        } catch (err) {
            logger.error(err, "Api.teamPermissions.put() failed", payload);
        }
        progressDialog.props.closeDialog();
    }

    static async convertToPresentationTemplate(presentationTemplate, fieldUpdates = {}) {
        await presentationTemplate.load();

        presentationTemplate.update({
            isTemplate: true,
            isPublished: false,
            ...fieldUpdates,
        });

        await presentationTemplate.updatePromise;
        await this.setTemplatePermissions([presentationTemplate]);

        trackActivity("PresentationTemplates", "PresentationTemplateAdded", null, null, {});

        return presentationTemplate;
    }

    static async publishPresentationTemplate(template) {
        template.update({ isPublished: true });
    }

    static async unpublishPresentationTemplate(template) {
        template.update({ isPublished: false });
    }

    static async deletePresentationTemplate(template) {
        await this.deleteTemplatePermissions([template]);
    }
}
